var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ykc-form',_vm._b({ref:"form",staticClass:"group-wrap",attrs:{"model":_vm.data,"rules":_vm.Rules}},'ykc-form',_vm.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }